import "./Home.scss";
import MessagesContainer from "../message/Messages.container";

export default function Home() {
  return (
    <div className="home">
      <MessagesContainer />
    </div>
  )
}